<template>
	<div>
		<v-card flat>
			<v-card-text>
				<brace
					style="height:90vh;"
					class="kbet-editor"
					:mode="'json'"
					@setHandler="
						h => {
							editorHandler = h;
						}
					"
				/>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {},
	data() {
		return {
			editorHandler: false,
			displayJSON: false,
			textMode: true,
			originalFileData: [],
		};
	},
	created() {},
	methods: {
		...mapMutations(['openSnackbar']),
	},
	computed: {
		// ...mapGetters('identifyStockist', ['selectedFile']),
	},
	mounted() {
		this.editorHandler.setValue(JSON.stringify(this.JSONInfo, null, 2));
	},
	watch: {
		JSONInfo: {
			deep: true,
			handler: (nv, cv) => {
				// console.log("New Value",nv)
				if (nv) {
					this.editorHandler.setValue(JSON.stringify(nv, null, 2));
				}
			},
		},
	},
	props: {
		JSONInfo: {
			type: Object,
			default: null,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
